// extracted by mini-css-extract-plugin
export default {"cancelReplacement":"styles_cancelReplacement__K6Mct","profileLink":"styles_profileLink__amVf0"};